export default "__VITE_ASSET__86a0b3d7__"